import { render, staticRenderFns } from "./CourseShowTeacher_zj.vue?vue&type=template&id=07864fba&scoped=true&"
import script from "./CourseShowTeacher_zj.vue?vue&type=script&lang=js&"
export * from "./CourseShowTeacher_zj.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowTeacher_zj.vue?vue&type=style&index=0&id=07864fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07864fba",
  null
  
)

export default component.exports